import { ValidatableInput } from 'app/validatableInput';
import Template from './template.hbs';
import './styles.scss';

let initialRows = false;

export class Textarea extends ValidatableInput {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            input: '.m-textarea__textarea', // Needed for displaying BE validation errors
            textarea: '.m-textarea__textarea',
            htmlarea: '.m-textarea__htmlarea',
            label: '.m-textarea__label',
            validationMessageOutlet: '.m-textarea__validationMessageOutlet',
        };
    }

    getPropsFromDom() {
        return {
            placeholder: this.dom.textarea.placeholder,
            value: this.dom.textarea.value,
            id: this.dom.textarea.id,
            disabled: this.dom.textarea.disabled,
            locked: this.dom.textarea
                ? this.dom.textarea.classList.contains('m-textarea__textarea--locked') : false,
            readonly: this.dom.textarea.readonly,
            rows: this.dom.textarea.rows,
            name: this.dom.textarea.name,
            label: !this.dom.label ? false : this.dom.label.innerHTML,
            noResize: this.dom.textarea
                ? this.dom.textarea.classList.contains('m-textarea__textarea--noResize') : false,
            overflow: this.dom.textarea
                ? this.dom.textarea.classList.contains('m-textarea__textarea--overflow') : false,
            error: !!this.dom.el.classList.contains('m-textarea--error'),
            explicitValidationMessageOutlet: !this.dom.validationMessageOutlet,
        };
    }

    domEvents() {
        if (this.dom.textarea) {
            this.dom.textarea.addEventListener('input', () => {
                this.events.emit('textareaInputChanged');
            });
        }
    }

    ready() {
        initialRows = parseInt(this.props.rows, 10);
    }

    getValue() {
        return this.dom.textarea.value;
    }

    setValue(value) {
        this.dom.textarea.value = value;
    }

    textareaGrow() {
        const paddingTop = parseInt(window.getComputedStyle(this.dom.textarea).getPropertyValue('padding-top'), 10);
        const paddingBottom = parseInt(
            window.getComputedStyle(this.dom.textarea).getPropertyValue('padding-bottom'),
            10,
        );
        const lineHeight = parseInt(window.getComputedStyle(this.dom.textarea).getPropertyValue('line-height'), 10);

        // Resetting the row count is necessary for recalculating the `scrollHeight` of the textarea.
        this.dom.textarea.rows = initialRows - 1;
        const innerHeight = this.dom.textarea.scrollHeight - paddingTop - paddingBottom;
        // An additional row (+ 1) is added to make space for the limit indicator.
        this.dom.textarea.rows = (innerHeight / lineHeight) + 1;
        this.setProps({ rows: this.dom.textarea.rows });
    }

    setFocus() {
        this.dom.textarea.focus();
    }

    highlightText(limit) {
        this.dom.htmlarea.innerHTML = `${this.getValue().slice(0, limit)}<em>${this.getValue().slice(limit)}</em>`;
    }

    getCurrentCursorPos() {
        return [this.dom.textarea.selectionStart, this.dom.textarea.selectionEnd];
    }

    setCurrentCursorPos(cursorPos) {
        let start = cursorPos[0];
        let end = cursorPos[1];

        // When the textarea is loaded the first time the cursorPos is [0, 0].
        // So we set the cursor at the end of the containing text,
        // otherwise it is at the very start which would be a weird behaviour.
        if (start === 0 && end === 0) {
            start = this.getValue().length;
            end = this.getValue().length;
        }
        this.dom.textarea.selectionStart = start;
        this.dom.textarea.selectionEnd = end;
    }
}
